import {
  CreatePrinterPayload,
  CreatePrinterStationPayload,
  UpdatePrinterPayload,
  UpdatePrinterStationPayload,
} from '@models/payload/printer';
import { ropoloRequest } from '@services/axios';

const getPrinters = async () => (await ropoloRequest.catalogPrintersList()).data;
const getPrinterDetail = async (id: string) => (await ropoloRequest.catalogPrintersDetail(id)).data;
const createPrinter = async (data: CreatePrinterPayload) => (await ropoloRequest.apiPrintersCreate(data)).data;
const editPrinter = async (data: UpdatePrinterPayload) => (await ropoloRequest.apiPrintersUpdate(data)).data;
const deletePrinter = async (id: string) => (await ropoloRequest.apiPrintersDelete(id)).data;

const getPrinterStations = async () => (await ropoloRequest.catalogPrinterstationsList()).data;
const getPrinterStationDetail = async (id: string) => (await ropoloRequest.catalogPrinterstationsDetail(id)).data;
const getPrinterStationCreate = async (payload: CreatePrinterStationPayload) =>
  (await ropoloRequest.apiPrinterstationsCreate(payload)).data;
const updatePrinterStation = async (payload: UpdatePrinterStationPayload) =>
  (await ropoloRequest.apiPrinterstationsUpdate(payload)).data;
const deletePrinterStation = async (id: string) => (await ropoloRequest.apiPrinterstationsDelete(id)).data;

const changePrintAllItemsOnFactor = async (status: boolean) =>
  (
    await ropoloRequest.identityVendorsSetprintitemsonfactoroptionUpdate({
      printAllItemsOnFactor: status,
    })
  ).data;

export {
  changePrintAllItemsOnFactor,
  createPrinter,
  deletePrinter,
  deletePrinterStation,
  editPrinter,
  getPrinterDetail,
  getPrinters,
  getPrinterStationCreate,
  getPrinterStationDetail,
  getPrinterStations,
  updatePrinterStation as getPrinterStationUpdate,
};
